<template>
  <div class="subordinate">
    <a-row class="table-search">
      <table-search
        :fileds="SearchFiled"
        :form="queryForm"
        @search="searchList"
        @reset="handleReset">
      </table-search>
    </a-row>
    <div class="tablebox">
      <a-table
        :columns="tableListColumns"
        :data-source="List"
        :pagination="pagination"
        class="goods-table table-multip"
        row-key="id"
        @change="tableChange"
      >
        <template slot="status" slot-scope="text">
          <div :class="{status: true, isDisabled: text !== ENABLED}">
            {{STATUS[text]}}
          </div>
        </template>
        <template slot="customerCode" slot-scope="text,data">
          <div class="ellipsis2">
            {{data.ext.customerCode}}
          </div>
        </template>
        <template slot="usermsg" slot-scope="text, data">
          <div class="ellipsis2">
            {{data.customerInfo.contacts}} {{data.customerInfo.telPhone}}
          </div>
        </template>
        <template slot="addrees" slot-scope="text, data">
          <a-tooltip placement="top">
            <template slot="title">
              {{data.customerInfo.provinceName}}{{data.customerInfo.cityName}}{{data.customerInfo.countyName}}{{data.customerInfo.address}}
            </template>
            <div class="ellipsis2">{{data.customerInfo.provinceName}}{{data.customerInfo.cityName}}{{data.customerInfo.countyName}}{{data.customerInfo.address}}</div>
          </a-tooltip>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import TableSearch from '@/components/TableSearch/index.vue'
import { getSubordinate } from './api'

const STATUS = {
  'ENABLED': '启用',
  'DISABLED': ' 禁用'
}
const ENABLED = 'ENABLED' // 启用

export default {
  name: "Subordinate",
  components: {
    TableSearch
  },
  props: {},
  data() {
    return {
      STATUS,
      ENABLED,
      pageSize: 10,
      tableListColumns: [
        {
            title: '名称',
            dataIndex: 'name',
            key: 'name',
            width: 160,
            scopedSlots: { customRender: 'name' },
        },
        {
            title: '编码',
            dataIndex: 'customerCode',
            key: 'customerCode',
            width: 160,
            scopedSlots: { customRender: 'customerCode' },
        },
        {
            title: '联系人信息',
            dataIndex: 'usermsg',
            key: 'usermsg',
            width: 160,
            scopedSlots: { customRender: 'usermsg' },
        },
        {
            title: '联系地址',
            dataIndex: 'addrees',
            key: 'addrees',
            width: 220,
            scopedSlots: { customRender: 'addrees' },
        },
        {
            title: '状态',
            dataIndex: 'status',
            key: 'status',
            width: 60,
            scopedSlots: { customRender: 'status' },
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            key: 'createTime',
            width: 160,
            scopedSlots: { customRender: 'createTime' },
        },
      ],
      List: [
      ],
      queryForm: {},
      SearchFiled: [
        {
          label: '名称',
          name: 'orgNameLike',
          type:'input',
          prop:{
            placeholder: '请输入',
          },
        },
      ],
      pagination: {
        current: 1,
        total: 0,
        defaultPageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "30", "40", "50"],
        onShowSizeChange: (current, pageSize) => {(this.pageSize = pageSize)},
        showQuickJumper: true,
        showTotal: (total) => `共 ${total} 条`,
      },
      accountData: {}
    };
  },
  computed: {},
  created() {
    this.getList()
  },
  mounted() {},
  methods: {
    filterData(data, value){
      return data === value ? null : data
    },
    searchList(){
      this.pagination.current = 1;
      this.getList()
    },
    handleReset() {
      this.queryForm = {}
      this.pagination.current = 1;
      this.getList()
    },
    getList() {
      const data = {
        ...this.queryForm,
        needCustomerInfo:true,
        type: 'ORG',
      }
      const {creditCode}=this.$store.state.user
      if(creditCode){
        data.creditCode=creditCode
      }else{
        this.accountData = JSON.parse(localStorage.getItem('accountData'));
        data.parentId=this.accountData?.id||null
      }
      const params = {
        size: this.pageSize,
        page: this.pagination.current,
        sort: 'createTime__DESC',
      }
      getSubordinate(data, params).then((res) => {
        this.List = res.records.map((e) => {
          return {
            ...e,
            createTime: moment(e.createTime).format('YYYY-MM-DD HH:mm:ss')
          }
        })
        this.pagination.total = res.total
      })
    },
    confirm() {
    },
    show() {
    },
    tableChange(pagination) {
      this.pagination = {
        ...this.pagination,
        current: pagination.current,
      };
      this.getList()
    },
  },
};
</script>

<style lang="less" scoped>
.subordinate {
  background: #fff;
  padding: 24px;
  border-radius:6px;
}
.tablebox {
  overflow-y: scroll;
  margin-bottom: 10px;
  margin-top: 15px;
  position: relative;
  .status {
    display: flex;
    align-items: center;
  }
  .status::before {
    content: '';
    width: 6px;
    height: 6px;
    background: #06B880;
    border-radius: 50%;
    display: inline-block;
    margin-right: 4px;
  }
  .isDisabled::before {
    background: #ED4934;
  }
  /deep/ .ant-table{
      .ant-table-thead ,.ant-table-scroll{
          background-color: #f5f5f5;
      }
      .ant-table-column-title{
        font-weight: bold;
      }
  }
}
</style>